/*!
 * jQuery Accordion 0.0.1
 * (c) 2014 Victor Fernandez <victor@vctrfrnndz.com>
 * MIT Licensed.
 */

;(function ( $, window, document, undefined ) {

  var pluginName = 'accordion',
      defaults = {
        transitionSpeed: 300,
        transitionEasing: 'ease',
        controlElement: '[data-control]',
        contentElement: '[data-content]',
        groupElement: '[data-accordion-group]',
        singleOpen: true
      };

  function Accordion(element, options) {
    this.element = element;
    this.options = $.extend({}, defaults, options);
    this._defaults = defaults;
    this._name = pluginName;
    this.init();
  }

  Accordion.prototype.init = function () {
    var self = this,
        opts = self.options;

    var $accordion = $(self.element),
        $controls = $accordion.find('> ' + opts.controlElement),
        $content =  $accordion.find('> ' + opts.contentElement);

    var accordionParentsQty = $accordion.parents('[data-accordion]').length,
        accordionHasParent = accordionParentsQty > 0;

    var closedCSS = { 'max-height': 0, 'overflow': 'hidden' };

    var CSStransitions = supportsTransitions();

    function debounce(func, threshold, execAsap) {
      var timeout;

      return function debounced() {
        var obj = this,
            args = arguments;

        function delayed() {
          if (!execAsap) func.apply(obj, args);
          timeout = null;
        };

        if (timeout) clearTimeout(timeout);
        else if (execAsap) func.apply(obj, args);

        timeout = setTimeout(delayed, threshold || 100);
      };
    }

    function supportsTransitions() {
      var b = document.body || document.documentElement,
          s = b.style,
          p = 'transition';

      if (typeof s[p] == 'string') {
        return true;
      }

      var v = ['Moz', 'webkit', 'Webkit', 'Khtml', 'O', 'ms'];

      p = 'Transition';

      for (var i=0; i<v.length; i++) {
        if (typeof s[v[i] + p] == 'string') {
          return true;
        } 
      }

      return false;
    }

    function requestAnimFrame(cb) {
      if(window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame) {
        return  requestAnimationFrame(cb) ||
          webkitRequestAnimationFrame(cb) ||
          mozRequestAnimationFrame(cb);
      } else {
        return setTimeout(cb, 1000 / 60);
      }
    }

    function toggleTransition($el, remove) {
      if(!remove) {
        $content.css({
          '-webkit-transition': 'max-height ' + opts.transitionSpeed + 'ms ' + opts.transitionEasing,
          'transition': 'max-height ' + opts.transitionSpeed + 'ms ' + opts.transitionEasing
        });
      } else {
        $content.css({
          '-webkit-transition': '',
          'transition': ''
        });
      }
    }

    function calculateHeight($el) {
      var height = 0;
      //afkk
      $el.children().each(function() {
        height = height + $(this).outerHeight(true) + 900;
      });

      $el.data('oHeight', height);
    }

    function updateParentHeight($parentAccordion, $currentAccordion, qty, operation) {
      var $content = $parentAccordion.filter('.open').find('> [data-content]'),
          $childs = $content.find('[data-accordion].open > [data-content]'),
          $matched;

      if(!opts.singleOpen) {
        $childs = $childs.not($currentAccordion.siblings('[data-accordion].open').find('> [data-content]'));
      }

      $matched = $content.add($childs);

      if($parentAccordion.hasClass('open')) {
        $matched.each(function() {
          var currentHeight = $(this).data('oHeight');

          switch (operation) {
            case '+':
              $(this).data('oHeight', currentHeight + qty);
              break;
            case '-':
              $(this).data('oHeight', currentHeight - qty);
              break;
            default:
              throw 'updateParentHeight method needs an operation';
          }

          $(this).css('max-height', $(this).data('oHeight'));
        });
      }
    }

    function refreshHeight($accordion) {
      if($accordion.hasClass('open')) {
        var $content = $accordion.find('> [data-content]'),
            $childs = $content.find('[data-accordion].open > [data-content]'),
            $matched = $content.add($childs);

        calculateHeight($matched);

        $matched.css('max-height', $matched.data('oHeight'));
      }
    }

    function closeAccordion($accordion, $content) {
      $accordion.trigger('accordion.close');

      if(CSStransitions) {
        if(accordionHasParent) {
          var $parentAccordions = $accordion.parents('[data-accordion]');

          updateParentHeight($parentAccordions, $accordion, $content.data('oHeight'), '-');
        }

        $content.css(closedCSS);

        $accordion.removeClass('open');
      } else {
        $content.css('max-height', $content.data('oHeight'));

        $content.animate(closedCSS, opts.transitionSpeed);

        $accordion.removeClass('open');
      }
    }

    function openAccordion($accordion, $content) {
      $accordion.trigger('accordion.open');
      if(CSStransitions) {
        toggleTransition($content);

        if(accordionHasParent) {
          var $parentAccordions = $accordion.parents('[data-accordion]');

          updateParentHeight($parentAccordions, $accordion, $content.data('oHeight'), '+');
        }

        requestAnimFrame(function() {
          $content.css('max-height', $content.data('oHeight'));
        });

        $accordion.addClass('open');
      } else {
        $content.animate({
          'max-height': $content.data('oHeight')
        }, opts.transitionSpeed, function() {
          $content.css({'max-height': 'none'});
        });

        $accordion.addClass('open');
      }
    }

    function closeSiblingAccordions($accordion) {
      var $accordionGroup = $accordion.closest(opts.groupElement);

      var $siblings = $accordion.siblings('[data-accordion]').filter('.open'),
          $siblingsChildren = $siblings.find('[data-accordion]').filter('.open');

      var $otherAccordions = $siblings.add($siblingsChildren);

      $otherAccordions.each(function() {
        var $accordion = $(this),
            $content = $accordion.find(opts.contentElement);

        closeAccordion($accordion, $content);
      });

      $otherAccordions.removeClass('open');
    }

    function toggleAccordion() {
      var isAccordionGroup = (opts.singleOpen) ? $accordion.parents(opts.groupElement).length > 0 : false;

      calculateHeight($content);

      if(isAccordionGroup) {
        closeSiblingAccordions($accordion);
      }

      if($accordion.hasClass('open')) {
        closeAccordion($accordion, $content);
      } else {
        openAccordion($accordion, $content);
      }
    }

    function addEventListeners() {
      $controls.on('click', toggleAccordion);

      $controls.on('accordion.toggle', function() {
        if(opts.singleOpen && $controls.length > 1) {
          return false;
        }

        toggleAccordion();
      });     
      $controls.on('accordion.refresh', function() {
        refreshHeight($accordion);
      });

      $(window).on('resize', debounce(function() {
        refreshHeight($accordion);
      }));
    }

    function setup() {
      $content.each(function() {
        var $curr = $(this);

        if($curr.css('max-height') != 0) {
          if(!$curr.closest('[data-accordion]').hasClass('open')) {
            $curr.css({ 'max-height': 0, 'overflow': 'hidden' });
          } else {
            toggleTransition($curr);
            calculateHeight($curr);

            $curr.css('max-height', $curr.data('oHeight'));
          }
        }
      });


      if(!$accordion.attr('data-accordion')) {
        $accordion.attr('data-accordion', '');
        $accordion.find(opts.controlElement).attr('data-control', '');
        $accordion.find(opts.contentElement).attr('data-content', '');
      }
    }

    setup();
    addEventListeners();
  };

  $.fn[pluginName] = function ( options ) {
    return this.each(function () {
      if (!$.data(this, 'plugin_' + pluginName)) {
        $.data(this, 'plugin_' + pluginName,
               new Accordion( this, options ));
      }
    });
  }

})( jQuery, window, document );



/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(document).ready(function() {

    $('.featured-icons-slider').owlCarousel({
      loop: false,
      margin: 0,
      nav: false,
      dots: false,
      lazyLoad:true,
      responsiveClass:true,
      responsive:{
        0:{
          items: 1,
          margin: 0,
          loop:true,
          autoplay:true,
          autoplayTimeout:2000,
          dots: true
        },
        600:{
          items: 2,
          margin:0,
          loop:true,
          autoplay:true,
          autoplayTimeout:2000,
          dots: true
        },
        1000:{
          items: 3

        }
      }
    });

  $('.testimonial-slider').owlCarousel({
    loop: false,
    margin: 0,
    nav: false,
    dots: false,
    lazyLoad:true,
    responsiveClass:true,
    responsive:{
      0:{
        items: 1,
        margin: 0,
        loop:true,
        autoplay:true,
        autoplayTimeout:2000,
        dots: true
      },
      600:{
        items: 2,
        margin:0,
        loop:true,
        autoplay:true,
        autoplayTimeout:2000,
        dots: true
      },
      1000:{
        items: 3

      }
    }
  });
  $('.related-products-items').owlCarousel({
    loop: false,
    margin: 25,
    nav: false,
    dots: false,
    lazyLoad:true,
    responsiveClass:true,
    responsive:{
      0:{
        items: 1,
        margin: 0,
        dots: true
      },
      640:{
        items: 2,
        margin:25,
        dots: true
      },
      768:{
        items: 3,
        margin:25,
        dots: true
      },
      1200:{
        items: 4

      }
    }
  });

  $('.Footer__Block > h2 > .mobile-clicker').click(function () {
    var $this = $(this).parents('.Footer__Block');
    $this.siblings().removeClass('open');

    if ($this.hasClass('open')) {
      $this.removeClass('open');
    } else {
      $this.addClass('open');
    }
  });
  $('.product-tab-vetical__item').accordion({
    "transitionSpeed": 300,
    "singleOpen" : false
  });
  $('.Collapsible__Fillter').accordion({
    "transitionSpeed": 300,
    "singleOpen" : true
  });


  if ( $(window).width() > 681 ) {
    $('.blog-col-wrap').masonry({

      itemSelector: '.blog-col',
      columnWidth: 0,
      gutter: 0
    });
  }


  $(".video-section .image-col-video").click(function(){
    $(this).addClass("active");
    //         $(this).next('iframe').play();
  });


  $('.new-blog-section-rel .blog-col-wrap').slick({
    infinite: false,
    dots: true,
    slidesToShow: 1,
    arrows: false,
    mobileFirst: true,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 681,
        settings: 'unslick'
      }
    ]
  });
  $('.product-featured').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    asNavFor: '.product-thumbnails'
  });
  $('.product-thumbnails').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    asNavFor: '.product-featured',
    dots: true,
    centerMode: true,
    focusOnSelect: true
  });
  $('.question-toggle .question').click(function(){
    $(this).toggleClass('active');
    var val= $(this).attr('data-id');
    $('.answer.' +val).slideToggle('slow');
  });



// 	$("body").on('click', ".popup-opener", function(e){
//       e.preventDefault();
//       var $parents = $(this).attr('data-popup-id');
//       var $customPop = $(this).attr('data-overlay');
//       $("div[data-popup='" + $parents + "']").addClass("active");
//       if($customPop !== "false"){$('.overlay').addClass("active");}
//       $("div[data-popup='" + $parents + "']").siblings(".cs-popup").removeClass("active");
//       $(this).addClass("active");
//     });

//     $("body").on('click', ".close-icon", function(e){
//       e.preventDefault();
//       var $parents = $('.active').attr('data-popup');
//       $(this).closest(".cs-popup").removeClass("active");
//       $('.overlay').removeClass("active");
//       $('.popup-opener').removeClass("active");
//     });

//     $("body").on('click', ".overlay", function(e){
//       e.preventDefault();
//       var $parents = $('.active').attr('data-popup');
//       $('.cs-popup').removeClass('active');
//       $('.overlay').removeClass("active");
//       $('.popup-opener').removeClass("active");
//     });

  $(document).keyup(function(e) {
    if (e.keyCode == 27) {
      $(".cs-popup").removeClass("active");
      $('.overlay').removeClass("active");
      $('.popup-opener').removeClass("active");
    }
  });


  $('#AnnouncementBar-rotate').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    infinite: true,
    speed: 20000,
    autoplay: true	
  });

  $(".video-play-icon").click(function(){
    $(this).parent().parent().addClass("active");
  });
  $('.toggle_menu').click(function(){
    $('body').addClass('menu_open');
  });
  $('.menu_close').click(function(){
    $('body').removeClass('menu_open');
  });
  $('.PageOverlay').click(function(){
    $('body').removeClass('menu_open');
  });
  $('body').on('click','.gift-checkbox .button.yes',function(){
    $(this).addClass('active');    
    $('.gift-checkbox .button.no').removeClass('active');
    $('.Drawer__Main').addClass('active');    
    $('#is-a-gift .gift-note-warrper').slideDown();
  });

  $('body').on('click','.gift-checkbox .button.no',function(){
    $(this).addClass('active');

    $('.Drawer__Main').removeClass('active');
    $('.gift-checkbox .button.yes').removeClass('active');
    $('#is-a-gift .gift-note-warrper').slideUp();
  });

  $('.cart_top_checkout').click(function(){
    $('.cart_bottom_checkout').trigger('click');
  });

  $("body").on("click",".afterpay-link_d",function(e){
    e.preventDefault();
    $("body").addClass("after_pop_active");
    $("#afterpay-modal-overlay_d").show();
  });

  $("body").on("click","#afterpay-modal-close_d",function(e){
    e.preventDefault();
    $("body").removeClass("after_pop_active");
    $("#afterpay-modal-overlay_d").hide();
  });

  function whenExists(element, callback) {
    const interval = setInterval(() => {
                                 if (document.querySelectorAll(element).length) {
      clearInterval(interval);
      callback();
    }
  }, 100);
  return interval;
}
                  whenExists('body:not(.template_product) .stamped-starrating', () => {

  jQuery('body:not(.template_product) .stamped-starrating').each(function () {
    if (jQuery(this).closest('.stamped-badge').attr('data-rating') === "0.0") {
      jQuery(this).closest('.stamped-badge').css('opacity', '0');
    }
  });

});

$('.ProductListWrapper .ProductList.has_addon_slider').slick({
  infinite: true,
  slidesToShow: 4,
  slidesToScroll: 1,
  arrows:true,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,        
        slidesToScroll: 2,
        dots: false
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
		dots: false
      }
    }    
  ]
});  
if($(window).width() < 769 ){      
  $('.bags_Wrp_slider').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows:true        
  });
  $('.bags_Wrp_slider .slick-prev').hide(); 
  $('.bags_Wrp_slider').on('afterChange', function(event, slick, currentSlide) { 

    //If we're on the first slide hide the Previous button and show the Next
    if (currentSlide === 0) {
      $('.bags_Wrp_slider .slick-prev').hide();
      $('.bags_Wrp_slider .slick-next').show();
    }
    else {
      $('.bags_Wrp_slider .slick-prev').show();         
    }

    //If we're on the last slide hide the Next button.        
    var  current_slde= $(this).find('.slick-active').index()+1;
    console.log(slick.slideCount,current_slde);	
    if (slick.slideCount === current_slde) {          
      $('.bags_Wrp_slider .slick-next').hide();
    }else{
      $('.bags_Wrp_slider .slick-next').show();
    }
  });
}  

$('[data-action="toggle-customsearch"]').on('click',function(e){
  e.preventDefault();
  $(this).toggleClass('active');    
  $(this).closest('.Header__Icon').find('.search_form').slideToggle();  
  $(this).closest('.Header__Icon').find('.Search__Input').trigger('focus');  
});

});

$(".Drawer__Close").click(function(){
  var curAttribute = true;
 $("#collection-filter-drawer").attr("aria-hidden", curAttribute)
  $("html").removeClass("no-scroll");
})



var filterList = document.querySelectorAll(".Drawer__Main .collection_sidebar_filter .Collapsible__Fillter");
filterList.forEach(item => {
  item.addEventListener("click", function(event) {
    var element = this;

    var filterItems = element.closest(".collection_sidebar_filter").querySelectorAll(".Collapsible__Fillter");
    filterItems.forEach(filterItem => {
      if(element != filterItem) {
        console.log("ddddddddd");
        filterItem.removeAttribute("open");
        filterItem.classList.remove("open");
        filterItem.querySelector("div[data-content]").style.maxHeight = "0px";
      }
    });

    console.log("------filter", this);
    if(element.classList.contains("open")) {
      element.setAttribute("open", "");
      element.classList.add("open");
      element.querySelector("div[data-content]").style.maxHeight = "1000px";
    } 
  });
});


var resetFilter = document.querySelector("#collection-filter-drawer .ButtonGroup__Item[data-action='reset-tags']");
var filterItems = document.querySelectorAll(".Drawer__Main .collection_sidebar_filter .Collapsible__Fillter .Linklist__Item");
resetFilter.addEventListener("click", function() {
  filterItems.forEach(item => {
    item.classList.remove("is-selected");
    item.querySelector("button").classList.remove("is-active");
  });
});

